module.exports = __webpack_public_path__ + "img/16.1ee3a5cd.jpg";